import { render } from "./ProfileComp.vue?vue&type=template&id=7f9f2eb2&scoped=true"
import script from "./ProfileComp.vue?vue&type=script&lang=js"
export * from "./ProfileComp.vue?vue&type=script&lang=js"

import "./ProfileComp.vue?vue&type=style&index=0&id=7f9f2eb2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9f2eb2"]])

export default __exports__